import { Box, Tab, Tabs } from "@mui/material";
import * as React from "react";
import { useTranslation } from "react-i18next";
import { useSearchParams } from "react-router-dom";
import { ConvertSVG } from "../ConvertSVG";
import { UberAdmin } from "../Settings/UberAdmin";
import { Activity } from "./Activity";
import { ActivationAdmin } from "./Activation";
import { AircraftAdmin } from "./AircraftAdmin";
import { AnnouncementsAdmin } from "./AnnouncementsAdmin";
import { AuthorizedAccounts } from "./AuthorizedAccounts";
import { EnterTheDojo } from "./EnterTheDojo";
import { FAAMapping } from "./FAAMapping";
import { FBOAdmin } from "./FBOAdmin";
import { MovableObstacleAdmin } from "./MovableObstacleAdmin";
import { QuarantineTab } from "./Quarantine";
import { SuperUserAdmin } from "./SuperUserAdmin";
import { TowingEquipmentAdminScreen } from "./TowingEquipmentAdmin";

type Props = {};

export const SuperAdmin: React.FC<Props> = () => {
  const { t } = useTranslation();
  const [searchParams, setSearchParams] = useSearchParams();

  // Get initial tab from URL, default to "authorized-accounts"
  const [activeTab, setActiveTab] = React.useState<string>(
    searchParams.get("tab") || "authorized-accounts"
  );

  // Update URL when tab changes
  const handleTabChange = (event: React.SyntheticEvent, newValue: string) => {
    setActiveTab(newValue);
    setSearchParams({ tab: newValue }, { replace: true });
  };

  return (
    <Box sx={{ p: 2 }}>
      <Tabs
        value={activeTab}
        onChange={handleTabChange}
        variant="scrollable"
        scrollButtons="auto"
      >
        <Tab value="authorized-accounts" label={t("screens.superAdmin.tabs.authorizedAccounts")} />
        <Tab value="fbos" label={t("screens.superAdmin.tabs.fbos")} />
        <Tab value="users" label={t("screens.superAdmin.tabs.users")} />
        <Tab value="faa-mapping" label={t("screens.superAdmin.tabs.faaMapping")} />
        <Tab value="announcements" label={t("screens.superAdmin.tabs.announcements")} />
        <Tab value="activity" label={t("screens.superAdmin.tabs.activity")} />
        <Tab value="movable-obstacles" label={t("screens.superAdmin.tabs.movableObstacles")} />
        <Tab value="towing-equipment" label={t("screens.superAdmin.tabs.towingEquipment")} />
        <Tab value="aircraft" label={t("screens.superAdmin.tabs.aircraft")} />
        <Tab value="labeling" label={t("screens.superAdmin.tabs.labeling")} />
        <Tab value="convert-svgs" label={t("screens.superAdmin.tabs.convertSvgs")} />
        <Tab value="system-status" label={t("screens.superAdmin.tabs.systemStatus")} />
        <Tab value="quarantine" label={t("screens.superAdmin.tabs.quarantine")} />
        <Tab value="activation" label={t("screens.superAdmin.tabs.activation")} />
      </Tabs>
      {activeTab === "authorized-accounts" && <AuthorizedAccounts />}
      {activeTab === "fbos" && <FBOAdmin />}
      {activeTab === "users" && <SuperUserAdmin />}
      {activeTab === "faa-mapping" && <FAAMapping />}
      {activeTab === "announcements" && <AnnouncementsAdmin />}
      {activeTab === "activity" && <Activity />}
      {activeTab === "movable-obstacles" && <MovableObstacleAdmin />}
      {activeTab === "towing-equipment" && <TowingEquipmentAdminScreen />}
      {activeTab === "aircraft" && <AircraftAdmin />}
      {activeTab === "labeling" && <EnterTheDojo />}
      {activeTab === "convert-svgs" && <ConvertSVG />}
      {activeTab === "system-status" && <UberAdmin />}
      {activeTab === "quarantine" && <QuarantineTab />}
      {activeTab === "activation" && <ActivationAdmin />}
    </Box>
  );
};
